import Vue from 'vue';
import Vuex from 'vuex';
import pt110 from './modules/pt110';
import pt120 from './modules/pt120';
import pt125 from './modules/pt125';
import pt180 from './modules/pt180';
import pt310 from './modules/pt310';
import pt320 from './modules/pt320';
import pt510 from './modules/pt510';
import sh060 from './modules/sh060';
import sh070 from './modules/sh070';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    gtmId: '',
  },
  getters: {
    gtmId: state => state.gtmId,
  },
  mutations: {
    setGtmId(state, gtmId) {
      state.gtmId = gtmId;
    },
  },
  modules: {
    pt110,
    pt120,
    pt125,
    pt180,
    pt310,
    pt320,
    pt510,
    sh060,
    sh070,
  },
});
